"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepperContext = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var SzTypographie_1 = __importDefault(require("../SzTypographie/SzTypographie"));
var SzTypographie_2 = __importDefault(require("../SzTypographie/SzTypographie"));
var ProgressBar_1 = __importDefault(require("react-bootstrap/ProgressBar"));
require("./SzStepper.scss");
var defaultValues = {
    activeStep: 0,
    header: [],
    variant: '',
    displayProgress: true
};
exports.StepperContext = react_1.createContext(defaultValues);
function SzStepper(props) {
    return react_1.default.createElement(exports.StepperContext.Provider, __assign({ value: props }, props));
}
function Step(_a) {
    var index = _a.index, children = _a.children;
    var activeStep = react_1.useContext(exports.StepperContext).activeStep;
    var stepClasses = function (key) {
        return classnames_1.default('step sz-body-stepper bg-white rounded', 'sz-body-stepper__step', {
            active: key === activeStep
        });
    };
    return react_1.default.createElement("div", { className: stepClasses(index) }, children);
}
function Header(props) {
    var _a = react_1.useContext(exports.StepperContext), header = _a.header, activeStep = _a.activeStep, variant = _a.variant, displayProgress = _a.displayProgress;
    var stepClasses = function (key) {
        return classnames_1.default('sz-header-stepper__step step d-flex align-items-center position-relative w-50 h-100', {
            underline: key < activeStep || key === activeStep,
            active: key === activeStep
        });
    };
    if (variant === 'simple') {
        var progressPurcent = (100 / header.length) * (activeStep + 1);
        return (react_1.default.createElement("div", { className: "sz-header-stepper d-flex bg-white rounded p-3 align-items-center" },
            react_1.default.createElement("div", { className: 'w-50' },
                react_1.default.createElement(SzTypographie_1.default, { className: "m-0" }, header[activeStep])),
            displayProgress && (react_1.default.createElement("div", { className: "d-flex ml-auto pt-4 position-relative" },
                react_1.default.createElement(SzTypographie_2.default, { className: "m-0 w-100 position-absolute simple-title text-uppercase text-nowrap" }, "\u00E9tape " + (activeStep + 1) + "/" + header.length),
                react_1.default.createElement(ProgressBar_1.default, { now: progressPurcent, className: "stepper-bar", variant: "success" })))));
    }
    return (react_1.default.createElement("div", { className: "sz-header-stepper d-flex bg-white rounded" }, header.map(function (item, key) {
        return (react_1.default.createElement("div", { key: key, className: stepClasses(key) },
            react_1.default.createElement("span", { className: "mr-2 font-weight-bold" },
                key + 1,
                "/",
                header.length),
            item));
    })));
}
SzStepper.SzStep = Step;
SzStepper.SzHeader = Header;
exports.default = SzStepper;
